<template>
  <div class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div>
            <div class="info-table py-4">
              <div class="info-table-item">
                <Subtitle
                  @exibirVermelhos="handleExibirVermelhos"
                  @exibirVerdes="handleExibirVerdes"
                  :setRed="setRed"
                ></Subtitle>
              </div>
              <div class="info-table-item">
                <vue-select
                  v-model="selectedFilterVulnerabilidade"
                  :options="optionsFilterVulnerabilidade"
                  label="label"
                  placeholder="Vulnerabilidade"
                  :clearable="true"
                  @input="onChangeFilterVulnerabilidade"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.label }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
              <div class="info-table-item">
                <download-files
                  :callback-pdf="generatePdf"
                  :data="displayedCadastros"
                  :fields="dataFields"
                  name="acompanhamento"
                >
                </download-files>
              </div>
            </div>
            <tabela-cadastros
              ref="table"
              :cadastros="displayedCadastros"
              :loading="loading"
              @filterSearch="filterSearch($event)"
            ></tabela-cadastros>
          </div>
        </b-tab>
        <b-tab title="Percentual">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Percentual
          </template>
          <div class="row mt-4">
            <div class="col-lg-5">
              <vue-select
                name="tipo-acompanhamento"
                v-model="tipoAcompanhamentoConsolidado"
                class="select-tipo-acompanhamento"
                :clearable="false"
                :options="optionsTipoAcompanhamentoConsolidado"
                label="label"
                placeholder="Tipo acompanhamento"
                @input="onChangeTipoAcompanhamentoConsolidado"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <tabela-resultado
            :loading="loading"
            :municipio="dadosDoResultadoMunicipio"
            :equipe="dadosDoResultadoEquipe"
            :micro_area="dadosDoResultadoMicroArea"
            :selectedEquipe="equipe"
            :selectedMicroArea="micro_area"
          >
          </tabela-resultado>
          <grafico-resultado
            :equipe="equipe"
            :micro_area="micro_area"
            :dadosSerieHistorica="dadosSerieHistorica"
            ref="graficoResultado"
          ></grafico-resultado>
        </b-tab>
        <b-tab title="Escore">
          <template v-slot:title>
            <i class="icofont-chart-histogram"></i> Escore
          </template>
          <div class="row mt-4">
            <div class="col-lg-6">
              <vue-select
                name="tipo-acompanhamento"
                v-model="tipoAcompanhamentoClassificacao"
                class="select-tipo-acompanhamento"
                :clearable="false"
                :options="optionsTipoAcompanhamentoClassificacao"
                label="label"
                placeholder="Tipo acompanhamento"
                @input="onChangeTipoAcompanhamentoClassificacao"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <tabela-classificacao
            :equipe="equipe"
            :micro_area="micro_area"
            :dadosDoMunicipio="dadosMunicipioClassificacao"
            :dadosDaEquipe="dadosEquipeClassificacao"
            :dadosDaMicroArea="dadosMicroAreaClassificacao"
            :selectedIndicador="tipoAcompanhamentoClassificacao"
          >
          </tabela-classificacao>
          <div>
            <grafico-classificacao
              :equipe="equipe"
              :micro_area="micro_area"
              :dadosSerieHistorica="dadosSerieHistorica"
              ref="graficoClassificacao"
            ></grafico-classificacao>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import {
  chartOptions,
  dataFields,
  groupFilterItems,
  optionsTipoAcompanhamentoConsolidado,
  optionsTipoAcompanhamentoClassificacao,
  optionsFilterVulnerabilidade,
} from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import TabelaResultado from './TabelaResultado.vue'
import GraficoResultado from './GraficoResultado.vue'
import GraficoClassificacao from './GraficoClassificacao.vue'
import TabelaClassificacao from './TabelaClassificacao.vue'

export default {
  name: 'Acompanhamento',
  components: {
    Subtitle,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    PulseLoader,
    TabelaCadastros,
    SelectsV2,
    TabelaResultado,
    GraficoResultado,
    GraficoClassificacao,
    TabelaClassificacao,
  },
  mixins: [utils],
  data() {
    return {
      disabledSelectResultado: false,
      loadingGrafico: false,
      micro_areas: [],
      micro_area: '',
      equipe: '',
      cadastros: [],
      cadastrosOriginais: [],
      dadosDoResultadoMunicipio: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      },
      dadosDoResultadoEquipe: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      },
      dadosDoResultadoMicroArea: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      },
      loading: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      tabsActive: 0,
      filterSearchTable: false,
      tituloTabelaResultado: '',
      dadosDaTabelaResultado: [],
      tipoAcompanhamentoConsolidado: {
        value: 'pessoas_acompanhadas',
        label: 'Pessoas acompanhadas',
        indicador: '30',
      },
      optionsTipoAcompanhamentoConsolidado: [
        ...optionsTipoAcompanhamentoConsolidado,
      ],
      chartData: [],
      chartOptions: {
        ...chartOptions,
      },
      setRed: false,
      dadosSerieHistorica: [],
      tipoAcompanhamentoClassificacao: {
        value: 'acompanhamento-por-cadastro-esus',
        label: 'Acompanhamento por cadastro e-SUS',
        indicador: '36',
      },
      optionsTipoAcompanhamentoClassificacao: [
        ...optionsTipoAcompanhamentoClassificacao,
      ],
      dadosMunicipioClassificacao: '',
      dadosEquipeClassificacao: '',
      dadosMicroAreaClassificacao: '',
      optionsFilterVulnerabilidade: [...optionsFilterVulnerabilidade],
      selectedFilterVulnerabilidade: null,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      let response = Filter.filtro(
        this.cadastros,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes,
        this.selectedFilterVulnerabilidade
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
  },
  methods: {
    /**
     * Habilita os filtros vermelho/verde
     *
     * @param {Boolean} vermelho
     * @param {Boolean} verde
     */
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (vermelho === true) {
        this.setRed = true
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
        return
      }
      if (verde === true) {
        this.setRed = false
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
        return
      }
      this.setRed = false
    },

    /**
     * Manipula ao selecionar um tipo de acompanhamento no percentual
     *
     * @param {Object} item
     */
    async onChangeTipoAcompanhamentoConsolidado(item) {
      this.tipoAcompanhamentoConsolidado = item
      this.setarResultadoMunicipio()
      this.setarResultadoEquipe()
      this.setarResultadoMicroArea()
    },

    /**
     * Manipula ao selecionar um tipo de acompanhamento no escore
     *
     * @param {Object} item
     */
    async onChangeTipoAcompanhamentoClassificacao(item) {
      this.tipoAcompanhamentoClassificacao = item

      this.setarClassificacaoMunicipio()

      if (
        item.value == 'acompanhamento-por-cadastro-esus' ||
        item.value == 'vinculo-acompanhamento-por-cadastro-esus'
      ) {
        if (this.equipe != '') {
          this.setarClassificacaoEquipe()
        }
        if (this.micro_area != '') {
          this.setarClassificacaoMicroArea()
        }
      }

      if (
        item.value == 'acompanhamento-por-parametro-de-cadastro' ||
        item.value == 'vinculo-acompanhamento-por-parametro-de-cadastro'
      ) {
        this.dadosMunicipioClassificacao = {
          resultado: 0,
          escore: 0,
          classificacao: '-',
        }
        this.dadosMicroAreaClassificacao = {
          resultado: 0,
          escore: 0,
          classificacao: '-',
        }
        if (this.equipe != '') {
          this.setarClassificacaoEquipe()
        }
      }
    },

    /**
     * Calcula e atualiza a classificação do município no gráfico.
     */
    setarClassificacaoMunicipio() {
      const result = Functions.resultadoClassificacaoMunicipio(
        this.tipoAcompanhamentoClassificacao,
        this.dadosDaTabelaResultado
      )
      this.dadosMunicipioClassificacao = {
        resultado: result.resultado,
        escore: result.escore,
        classificacao: result.classificacao,
        dados: result.dados,
      }
      this.$refs.graficoClassificacao.serieHistoricaMunicipio(
        this.dadosSerieHistorica,
        this.tipoAcompanhamentoClassificacao
      )
    },

    /**
     * Calcula e atualiza a classificação da equipe no gráfico.
     */
    setarClassificacaoEquipe() {
      const result = Functions.resultadoClassificacaoEquipe(
        this.tipoAcompanhamentoClassificacao,
        this.dadosDaTabelaResultado,
        this.equipe.nu_ine
      )
      this.dadosEquipeClassificacao = {
        resultado: result.resultado,
        escore: result.escore,
        classificacao: result.classificacao,
        dados: result.dados,
      }
      this.$refs.graficoClassificacao.serieHistoricaEquipe(
        this.dadosSerieHistorica,
        this.tipoAcompanhamentoClassificacao,
        this.equipe
      )
    },

    /**
     * Calcula e atualiza a classificação da microárea no gráfico.
     */
    setarClassificacaoMicroArea() {
      const result = Functions.resultadoClassificacaoMicroArea(
        this.tipoAcompanhamentoClassificacao,
        this.dadosDaTabelaResultado,
        this.equipe.nu_ine,
        this.micro_area
      )
      this.dadosMicroAreaClassificacao = {
        resultado: result.resultado,
        escore: result.escore,
        classificacao: result.classificacao,
        dados: result.dados,
      }
      this.$refs.graficoClassificacao.serieHistoricaMicroArea(
        this.dadosSerieHistorica,
        this.tipoAcompanhamentoClassificacao,
        this.equipe,
        this.micro_area
      )
    },

    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Atualiza o filtro para exibir registros classificados como vermelhos.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    /**
     * Atualiza o filtro para exibir registros classificados como verdes.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} event Equipe selecionada
     */
    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.dadosDoResultadoMicroArea.numerador = 0
      this.dadosDoResultadoMicroArea.denominador = 0
      this.dadosDoResultadoMicroArea.resultado = 0
      let equipe = this.$store.state.equipesV2.find((el) => {
        return el.ine_esf_eap == event.ine_esf_eap
      })
      if (equipe) {
        this.equipe = {
          nu_ine: equipe.ine_esf_eap,
          no_equipe: equipe.no_esf_eap,
          nu_cnes: equipe.nu_cnes,
        }
      }
      if (event !== null) {
        this.tipoAcompanhamentoClassificacao = {
          value: 'acompanhamento-por-cadastro-esus',
          label: 'Acompanhamento por cadastro e-SUS',
          indicador: '36',
        }
        this.tabsActive = 0
        this.micro_area = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        try {
          this.loading = true
          this.buscarCadastrosPorEquipe()
        } catch (error) {
          console.log(error)
        }
      } else {
        this.dadosDoResultadoEquipe.numerador = 0
        this.dadosDoResultadoEquipe.denominador = 0
        this.dadosDoResultadoEquipe.resultado = 0
        this.cadastros = []
        this.cadastrosOriginais = []
        this.micro_area = ''
        this.equipe = ''
        this.dadosEquipeClassificacao = ''
        this.dadosMicroAreaClassificacao = ''
      }
      this.setarClassificacaoMunicipio()
      this.setarResultadoEquipe()
      this.setarClassificacaoEquipe()
    },

    /**
     * Calcula e atualiza o resultado do município no gráfico.
     */
    setarResultadoMunicipio() {
      const result = Functions.resultadoDoMunicipio(
        this.tipoAcompanhamentoConsolidado,
        this.dadosDaTabelaResultado
      )
      this.dadosDoResultadoMunicipio.numerador = result.numerador
      this.dadosDoResultadoMunicipio.denominador = result.denominador
      this.dadosDoResultadoMunicipio.resultado = result.resultado
      this.$refs.graficoResultado.serieHistoricaMunicipio(
        this.dadosSerieHistorica,
        this.tipoAcompanhamentoConsolidado
      )
    },

    /**
     * Calcula e atualiza o resultado da equipe no gráfico.
     */
    setarResultadoEquipe() {
      const result = Functions.resultadoDaEquipe(
        this.tipoAcompanhamentoConsolidado,
        this.dadosDaTabelaResultado,
        this.equipe.nu_ine
      )
      this.dadosDoResultadoEquipe.numerador = result.numerador
      this.dadosDoResultadoEquipe.denominador = result.denominador
      this.dadosDoResultadoEquipe.resultado = result.resultado
      this.$refs.graficoResultado.serieHistoricaEquipe(
        this.dadosSerieHistorica,
        this.tipoAcompanhamentoConsolidado,
        this.equipe
      )
    },

    /**
     * Calcula e atualiza o resultado da microárea no gráfico.
     */
    async setarResultadoMicroArea() {
      if (this.micro_area != '') {
        const result = Functions.resultadoDaMicroArea(
          this.tipoAcompanhamentoConsolidado,
          this.dadosDaTabelaResultado,
          this.equipe.nu_ine,
          this.micro_area
        )
        this.dadosDoResultadoMicroArea.numerador = result.numerador
        this.dadosDoResultadoMicroArea.denominador = result.denominador
        this.dadosDoResultadoMicroArea.resultado = result.resultado
        this.$refs.graficoResultado.serieHistoricaMicroArea(
          this.dadosSerieHistorica,
          this.tipoAcompanhamentoConsolidado,
          this.equipe,
          this.micro_area
        )
      }
    },

    /**
     * Manipula a alteração da microárea selecionada.
     *
     * @param {Object} event Microárea selecionada
     */
    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.tabsActive = 0
      this.dadosDoResultadoMicroArea.numerador = 0
      this.dadosDoResultadoMicroArea.denominador = 0
      this.dadosDoResultadoMicroArea.resultado = 0
      this.micro_area = event?.micro_area
      if (event !== null) {
        this.situacao = ''
        this.loading = true
        this.disabledSelectResultado = true
        this.tipoAcompanhamentoClassificacao = {
          value: 'acompanhamento-por-cadastro-esus',
          label: 'Acompanhamento por cadastro e-SUS',
          indicador: '36',
        }
        if (this.micro_area !== undefined) {
          this.buscarCadastrosPorMicroArea()
        }
      } else {
        // cadastros por equipe
        this.buscarCadastrosPorEquipe()
        this.micro_area = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.disabledSelectResultado = false
        this.dadosMicroAreaClassificacao = ''
        this.onChangeEquipe(this.equipe)
      }
      this.setarClassificacaoMunicipio()
      this.setarClassificacaoEquipe()
      this.setarResultadoMicroArea()
      this.setarClassificacaoMicroArea()
    },

    /**
     * Busca os cadastros por equipe
     */
    async buscarCadastrosPorEquipe() {
      try {
        this.loading = true
        let response = await Functions.getCadastrosPorEquipe(
          this.$store.state.cod_ibge,
          this.equipe.nu_ine
        )
        if (response) {
          this.cadastros = response
          this.cadastrosOriginais = response
          this.setRed = true
          this.filtros(true, false)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Busca os cadastros por microárea
     */
    async buscarCadastrosPorMicroArea() {
      try {
        this.loading = true
        let response = await Functions.getCadastrosPorMicroArea(
          this.$store.state.cod_ibge,
          this.equipe.nu_ine,
          this.micro_area
        )
        if (response) {
          this.cadastros = response
          this.cadastrosOriginais = response
          this.setRed = true
          this.filtros(true, false)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Manipula a alteração da vulnerabilidade
     *
     * @param {Object} item
     */
    onChangeFilterVulnerabilidade(item) {
      this.handleExibirVermelhos(true)
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.micro_area
      )
    },

    /**
     * Inicializa os dados
     */
    async init() {
      try {
        // dados da série histórica
        let response2 = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[30,36,37,55,56]`
        )
        this.dadosDaTabelaResultado = response2.data
        this.dadosSerieHistorica = response2.data
        // dados do município
        this.setarResultadoMunicipio()
        this.setarClassificacaoMunicipio()

        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let nu_ine_profissional =
            this.$store.state.id_funcao == 8 ||
            this.$store.state.id_funcao == 14 ||
            this.$store.state.id_funcao == 15
              ? this.$store.state.nu_ine_vinculada
              : this.$store.state.nu_ine
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == nu_ine_profissional
          })
          if (equipe) {
            this.equipe = {
              nu_ine: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
              nu_cnes: equipe.nu_cnes,
            }
            this.buscarCadastrosPorEquipe()
            this.setarResultadoEquipe()
            this.setarClassificacaoEquipe()
          }
        }

        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              nu_ine: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
              nu_cnes: equipe.nu_cnes,
            }
            this.setarResultadoEquipe()
            this.setarClassificacaoEquipe()
          }
          this.micro_area = this.$store.state.micro_area
          this.buscarCadastrosPorMicroArea()
          this.setarResultadoMicroArea()
          this.setarClassificacaoMicroArea()
        }

        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
  },
  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
